import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { last, map, switchMap, takeWhile } from 'rxjs/operators';

import {
  TcposScoApiService,
  TcposScoPaymentState,
} from '@core/services/api/tcpos-sco/tcpos-sco-api.service';

const POLL_INTERVAL_MS = 1500;

@Injectable({
  providedIn: 'root',
})
export class TcposScoService {
  constructor(private readonly tcposScoApi: TcposScoApiService) {}

  startPayment$(agentOrderId: string) {
    return this.tcposScoApi.startPayment$(agentOrderId);
  }

  cancelPayment$(agentOrderId: string) {
    return this.tcposScoApi.cancelPayment$(agentOrderId);
  }

  pollPaymentStatus$(agentOrderId: string): Observable<TcposScoPaymentState> {
    return timer(0, POLL_INTERVAL_MS).pipe(
      switchMap(() => this.tcposScoApi.getPaymentStatus$(agentOrderId)),
      map(response => response.state),
      takeWhile(state => state === 'waiting', true),
      last(),
    );
  }

  runPaymentFlow$(agentOrderId: string): Observable<TcposScoPaymentState> {
    return this.tcposScoApi
      .startPayment$(agentOrderId)
      .pipe(switchMap(() => this.pollPaymentStatus$(agentOrderId)));
  }
}
